module.exports = __webpack_public_path__ + "static/media/icwdial_101.6d4c0f7b.ico";